<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card">
                <h4 v-if="client && client.key && site && site.key" class="p-d-flex p-ai-baseline">
                    <router-link icon="pi pi-angle-left" class="p-button p-button-icon p-mr-4" :to="{ name: 'asset', params: { client_id: client.key, site_id: site.key, id: asset.key } }">
                        <i class="pi pi-angle-left"></i>
                        Back
                    </router-link>
                    <span>
                        <router-link :to="{ name: 'sites', params: { id: client.key } }">{{ client.name }}</router-link> /
                        <router-link :to="{ name: 'site', params: { client_id: client.key, id: site.key } }">
                            {{ site.name }}
                        </router-link> /
                        <router-link :to="{ name: 'asset', params: { client_id: client.key, site_id: site.key, id: asset.key } }">Asset
                            #{{ asset.asset_id }}
                        </router-link> /
                        Asset Activity Log
                    </span>
                </h4>
                <DataTable :exportFilename="exportName()" ref="dt" :value="logs" class="p-datatable-customers" :rows="10" dataKey="id" :loading="false" id="print">
                    <template #header>
                        <div class="p-d-flex p-jc-between">
                            <div style="text-align: left">
                                <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
                            </div>
                            <div>
                                <Button icon="pi pi-print" label="Print" @click="print($event)" />
                            </div>
                        </div>
                    </template>
                    <template #empty>
                        No logs found.
                    </template>
                    <template #loading>
                        Loading activity data. Please wait.
                    </template>
                    <Column field="site_name" header="Site">
                        <template #body="slotProps">
                            {{ slotProps.data.site_name }}
                        </template>
                    </Column>
                    <Column field="meta.asset_id" header="ID">
                        <template #body="slotProps">
                            <!-- <span v-if="slotProps.data.checked.name != 'In'">No ID Assigned</span> -->
                            <span>#{{ slotProps.data.meta.asset_id }}</span>
                        </template>
                    </Column>
                    <Column field="datetime" header="When" :sortable="true" :exportFormatFn="true">
                        <template #body="slotProps">
                            {{ format_date(slotProps.data.timestamp.seconds * 1000) }}
                        </template>
                    </Column>
                    <Column field="full_name" header="Inspected By" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.full_name }}
                        </template>
                    </Column>
                    <Column field="company" header="Company" :sortable="true">
                        <template #body="slotProps">
                            {{ slotProps.data.company }}
                        </template>
                    </Column>
                    <Column field="checked.name" header="Status">
                        <template #body="slotProps">
                            {{ slotProps.data.checked.name }}
                        </template>
                    </Column>
                    <Column field="pass" header="Pass/Fail Status">
                        <template #body="slotProps">
                            <span v-if="slotProps.data.pass">{{ slotProps.data.pass }}</span>
                        </template>
                    </Column>
                    <Column field="notes" header="Notes">
                        <template #body="slotProps">
                            {{ slotProps.data.notes }}
                        </template>
                    </Column>
                </DataTable>
                <!-- <Paginator :rows="limit" :totalRecords="siteAttendance.length" @page="updatePage"></Paginator> -->
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase';
import moment from 'moment';

export default {
    data() {
        return {
            count: 0,
            logs: [],
            pages: [],
            siteAttendance: []
        }
    },
    firestore() {
        return {
            siteAttendance: db.collection('attendance').where('client_id', '==', this.$route.params.client_id).where('site_id', '==', this.$route.params.id),
            site: db.collection('sites').doc(this.$route.params.id),
            client: db.collection('clients').doc(this.$route.params.client_id),
            asset: db.collection('assets').doc(this.$route.params.asset_id),
        }
    },
    mounted() {
        this.updatePage({ page: 0 });
    },
    methods: {
        format_date(value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY @ hh:mma')
            }
        },
        exportName() {

            let clientName = this.client.name;
            let siteName = this.site.name;
            let currentDate = moment(new Date()).format('YYYY-MM-DD');

            return clientName + '-' + siteName + '-' + currentDate;
        },
        exportCSV() {
            this.$refs.dt.exportCSV();
        },
        print() {
            window.print();
        },
        updatePage(e) {
            let start = this.pages[e.page] != undefined ? this.pages[e.page].timestamp : 0;
            let logs = [];
            if (!this.logs.length) {
                logs = db.collection('attendance')
                    .where('client_id', '==', this.$route.params.client_id)
                    .where('site_id', '==', this.$route.params.id)
                    .where('asset_id', '==', this.$route.params.asset_id)
                    .orderBy('timestamp', 'desc')
                    .limit(this.limit);
            } else {
                if (start == 0) {
                    logs = db.collection('attendance')
                        .orderBy('timestamp', 'desc')
                        .startAfter(this.logs[this.logs.length - 1].timestamp)
                        .where('client_id', '==', this.$route.params.client_id)
                        .where('site_id', '==', this.$route.params.id)
                        .where('asset_id', '==', this.$route.params.asset_id)
                        .limit(this.limit);
                } else {
                    logs = db.collection('attendance')
                        .orderBy('timestamp', 'desc')
                        .startAt(start).limit(this.limit)
                        .where('client_id', '==', this.$route.params.client_id)
                        .where('site_id', '==', this.$route.params.id)
                        .where('asset_id', '==', this.$route.params.asset_id)
                        .limit(this.limit);
                }
            }

            logs.get().then((logSnapshots) => {
                this.logs = [];
                logSnapshots.forEach(doc => {
                    this.logs.push(doc.data());
                });
                if (this.pages[e.page] == undefined) {
                    this.pages.push(this.logs[0]);
                }
            });
        }
    },
}
</script>

<style lang="scss">
@media print {
    #print button {
        display: none;
    }

    @page {
        margin: 0;
    }
}
</style>
